import { Typography } from '@material-ui/core'

import { PriceRow } from '../../../components/PriceRow'
import { getTranslate } from '../../../localization'
import { PromotionAllocation } from '../../../types/cart'

type PromotionAllocationRowsProps = {
  allocations?: PromotionAllocation[]
  currency?: string
  roomLabel: (roomStayReference: string, index: number) => string
}

/**
 * Explains where an already-listed promotion discount landed.
 *
 * These are allocation rows, not further discounts: the promotion's own PriceRow remains the
 * only total-facing row. Keeping this presentation shared prevents the cart review and payment
 * steps from telling a booker different stories about the same money.
 */
const PromotionAllocationRows = ({
  allocations = [],
  currency,
  roomLabel
}: PromotionAllocationRowsProps) =>
  allocations.length > 0 ? (
    <div>
      <Typography variant="caption" color="textSecondary">
        {getTranslate('Applied to')}
      </Typography>
      {allocations.map((allocation, index) => (
        <PriceRow
          key={`${allocation.roomStayReference}-${allocation.discountMinor}-${index}`}
          label={`↳ ${roomLabel(allocation.roomStayReference, index)}`}
          minorAmount={allocation.discountMinor}
          currency={allocation.currency || currency || ''}
          isDiscount
        />
      ))}
    </div>
  ) : null

export default PromotionAllocationRows
